import * as React from "react";
import * as userService from "../../../models/services/userService";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog } from "../../framework/Dialog/Dialog";
import { SendButton } from "source/components/framework/Button/SendButton";
import { AppUtils } from "source/framework/appUtils";
import { ConfirmationDialogResult } from "ui/Scripts/source/models/enums";
import { IUserTokenData } from "source/models/user/userTokenData";

export interface IUserEditSendEmailDialogProp {
    userId: string;
    companyId: string;
    onCancel: (tokenData: IUserTokenData) => void;
}

export const UserEditSendEmailDialog = (props: IUserEditSendEmailDialogProp) => {
    const handleSendInvitationLink = async () => {
        if (await AppUtils.showConfirmationDialog(Translations.SendEmailInvitationConfirmation, false) !== ConfirmationDialogResult.Yes) return;
        const result = await AppUtils.callService(() => userService.sendInvitationEmail(props.userId, props.companyId));
        if (!result) return;
        props.onCancel(result.tokenData);
    };

    const handleSendPasswordChangeLink = async () => {
        if (await AppUtils.showConfirmationDialog(Translations.SendPasswordChangeEmailConfirmation, false) !== ConfirmationDialogResult.Yes) return;
        const result = await AppUtils.callService(() => userService.sendPasswordChangeEmail(props.userId, props.companyId));
        if (!result) return;
        props.onCancel(result.tokenData);
    };

    return (
        <Dialog
            id="userEditSendEmailDialog"
            maxWidth="xs"
            title={Translations.InvitationPasswordReset}
            body={
                <>
                    <SendButton
                        fullWidth={true}
                        onClick={handleSendInvitationLink}
                    >
                        {Translations.SendEmailInvitation}
                    </SendButton>
                    <SendButton
                        fullWidth={true}
                        onClick={handleSendPasswordChangeLink}
                        sx={{ marginTop: "0.5rem" }}
                    >
                        {Translations.SendPasswordChangeEmail}
                    </SendButton>
                </>
            }
            buttons={[
                { title: Translations.Close, variant: "outlined", onClick: () => props.onCancel(null) }
            ]}
            onClose={() => props.onCancel(null)}/>
    );
};